export const Images = {
  appStore: require("../../assets/images/app-store.png"),
  playStore: require("../../assets/images/play-store.png"),
  signup: require("../../assets/images/sign-up.png"),
};
